<template>
  <div>
    <el-form :model="value" :rules="rules">
      <div v-if="value.event">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item @click.native="value.event = null">Actions</el-breadcrumb-item>
          <el-breadcrumb-item>{{ customEventComponent || value.event }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form-item prop="event">
          <el-autocomplete
            v-model="value.event"
            class="autocomplete-list"
            :fetch-suggestions="getEventNodes"
            v-if="
              ![
                'goto',
                'capture',
                'startflow',
                'callApi',
                '$display',
                'handover_router',
                'set',
                'form_processor',
                'redirect_bot',
                'azure_queue',
              ].includes(value.event)
            "
          >
            <div slot="prepend" style="width: 40px">Action</div>
          </el-autocomplete>
        </el-form-item>

        <component
          v-if="eventComponentIsValid"
          :value="value"
          :is="eventComponent"
          :previous-node="previousNode"
        ></component>
      </div>

      <div style="text-align: center" v-else>
        <div style="display: flex; flex-wrap: wrap; justify-content: center">
          <div
            :style="{
              width: !isGenAIModule && '420px',
              textAlign: 'left',
            }"
          >
            <el-button
              v-for="(action, index) in eventNodeTypes"
              v-show="showAdvanced || !action.isAdvanced"
              :key="`event-node-selector-button-${index}`"
              size="medium"
              round
              style="width: 200px; margin-bottom: 4px; margin-left: 5px; margin-right: 5px"
              @click="setType(action.name)"
              :style="{
                margin: isGenAIModule && '10px 0',
                display: isGenAIModule && 'block',
              }"
            >
              {{ action.label }}
            </el-button>
          </div>
        </div>
        <!-- A text button to Toggle Show Advanced -->
        <el-switch
          v-if="!isGenAIModule"
          v-model="showAdvanced"
          active-text="Advance Actions"
          inactive-text="Basic Actions"
          style="margin-top: 1.2em; margin-bottom: 0em"
        />
      </div>
    </el-form>
  </div>
</template>

<script>
import _ from "lodash";
import EventNodeSelectorNext from "./Next.vue";
import { EVENT_NODE_TYPES } from "./Types/Index";
import TypeComponentCallapi from "./Types/CallApi";
import TypeComponentCapture from "./Types/Capture";
import TypeComponentGoto from "./Types/Goto";
import TypeComponentDisplay from "./Types/Display";
import TypeComponentTab from "./Types/Tab";
import TypeComponentStartflow from "./Types/Startflow";
import TypeComponentCustomevent from "./Types/CustomEvent";
import TypeComponentSet from "./Types/Set";
import TypeComponentForm from "./Types/Form";
import TypeComponentRedirectbot from "./Types/RedirectBot.vue";
import TypeComponentAzurequeue from "./Types/AzureQueue.vue";
import TypeComponentSetdepartment from "./Types/SetDepartment.vue";
import TypeComponentSelectpersona from "./Types/SelectPersona.vue";
import TypeComponentGenairesponse from "./Types/GenAIResponse.vue";

export default {
  components: {
    EventNodeSelectorNext,
    TypeComponentCallapi,
    TypeComponentCapture,
    TypeComponentGoto,
    TypeComponentDisplay,
    TypeComponentTab,
    TypeComponentStartflow,
    TypeComponentCustomevent,
    TypeComponentSet,
    TypeComponentForm,
    TypeComponentRedirectbot,
    TypeComponentAzurequeue,
    TypeComponentSetdepartment,
    TypeComponentSelectpersona,
    TypeComponentGenairesponse,
  },
  name: "EventNodeSelector",
  props: {
    value: {
      event: "",
      data: {},
      side_effects: Array,
    },
    previousNode: {},
    nodeType: {
      type: String,
      default() {
        return "";
      },
    },
    isGenAIModule: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    const isLinkNotFound = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Field is required"));
      }

      if (typeof value === "string") {
        if (this.value.event == "goto") {
          if (!this.$store.state.nodes.content[value]) {
            return callback(new Error("Please enter a valid content node"));
          }
        } else if (this.value.event == "callApi") {
          if (!this.searchApiMappings(value)) {
            return callback(new Error("Please enter a valid content node"));
          }
        }
      }

      return callback();
    };
    return {
      showAdvanced: false,
      availableEvents: [
        "$display",
        "$tab",
        "callApi",
        "capture",
        "goto",
        "startflow",
        "redirectbot",
        "select_persona",
      ],
      customEventComponent: _.get(this.value, "data.custom_component", null),
      rules: {
        event: [
          {
            required: true,
            trigger: "blur",
            message: "Event is required",
          },
        ],
        data: [
          {
            validator: isLinkNotFound,
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    eventNodeTypes() {
      let events = EVENT_NODE_TYPES;

      if (this.nodeType === "flow") {
        const allowedEvent = ["capture", "callApi", "startflow", "set", "custom event"];

        events = events.filter((event) => allowedEvent.includes(event.name));
      }

      if (this.isGenAIModule) {
        const allowedEvent = ["goto", "callApi"];

        events = events.filter((event) => allowedEvent.includes(event.name));
      }
      return events;
    },
    /**
     * @description Check if component is valid / imported before render
     * @return {boolean}
     */
    eventComponentIsValid() {
      const isExist = _.has(this.$options.components, this.eventComponent);

      console.log(isExist, " eventComponentIsValid", this.eventComponent);
      return isExist;
    },

    /**
     * @description Computed EventType component for rendering
     * @return {string}
     */
    eventComponent() {
      if (this.customEventComponent) {
        return `TypeComponent${this.customEventComponent}`;
      }
      let _name = this.value.event;

      if (_name === "$display") {
        _name = "Display";
      } else if (_name === "$tab") {
        _name = "Tab";
      } else if (_name === "set") {
        _name = "Set";
      } else if (_name === "form_processor") {
        _name = "Form";
      } else if (_name === "redirect_bot") {
        _name = "Redirectbot";
      } else if (_name === "azure_queue") {
        _name = "Azurequeue";
      } else if (_name === "select_persona") {
        _name = "Selectpersona";
      } else if (_name === "genai_bot_response") {
        _name = "Genairesponse";
      } else if (!this.availableEvents.includes(_name)) {
        _name = "CustomEvent";
      } else if (_name === "capture" && this.value.data.key == "userQueryTopic") {
        _name = "SetDepartment";
      }

      const _capitalize = _.capitalize(_name);
      const _componentName = `TypeComponent${_capitalize}`;
      return _componentName;
    },
  },
  mounted() {
    if (typeof this.value?.data?.next === "string") {
      this.value.data.next = {
        event: "goto",
        data: this.value.data.next,
      };
    }
  },
  methods: {
    /**
     * @description Search available api mappings
     * @param {string} value
     * @return {[]}
     */
    searchApiMappings(value) {
      return this.$store.state.search.api_mappings.search(value);
    },

    /**
     * @description
     */
    setType(type) {
      this.customEventComponent = null;
      let simpleTypes = [
        "$display",
        "callApi",
        "goto",
        "$tab",
        "capture",
        "startflow",
        "set",
        "form_processor",
        "azure_queue",
        "gpt",
        "select_persona",
        "genai_bot_response",
      ];

      // Set Action
      if (simpleTypes.includes(type)) {
        this.$set(this.value, "event", type);
      }

      // Set Data
      switch (type) {
        case "goto":
          this.$set(this.value, "data", "");
          break;
        case "capture":
          this.$set(this.value, "data", {});
          break;
        case "$set_department":
          this.$set(this.value, "event", "capture");
          this.$set(this.value, "data", {
            key: "userQueryTopic",
            value: "",
            next: { event: "goto", data: "" },
          });
          break;
        case "$set_language":
          this.$set(this.value, "event", "capture");
          this.$set(this.value, "data", {
            key: "entities.LANGUAGE",
            value: "en",
            next: { event: "goto", data: "" },
          });
          break;
        case "set":
          this.$set(this.value, "data", {
            data: {
              variable1: "value1",
              variable2: "value2",
              variable3: null,
            },
            next: {
              event: "goto",
              data: "",
            },
          });
          break;
        case "escalate":
          this.$set(this.value, "event", "handover_router");
          this.$set(this.value, "data", "");
          break;
        case "gpt":
        case "select_persona":
          this.$set(this.value, "data", {
            value: "",
          });
          break;
        case "custom event":
          this.$set(this.value, "event", "custom event");
          this.$set(this.value, "data", "");
          break;
        case "startflow":
          this.$set(this.value, "data", {
            id: "",
            value: "",
          });
          break;
        case "form_processor":
          this.$set(this.value, "data", "event=embedded&id=");
          break;

        case "redirect_bot":
          this.$set(this.value, "event", "capture");
          this.$set(this.value, "data", {
            key: "redirect",
            value: null,
            custom_component: "Redirectbot",
          });
          this.customEventComponent = "Redirectbot";
          break;
        case "azure_queue":
          this.$set(this.value, "data", {});
          break;
        case "genai_bot_response":
          this.$set(this.value, "data", {
            userMessage: "",
          });
          break;
        default:
      }
    },

    getEventNodes(value, cb) {
      if (value) {
        cb(this.$store.state.search.event.search(value));
      }
    },
  },
};
</script>

<style>
.autocomplete-list {
  margin-top: 15px;
  width: 100%;
}
.el-scrollbar ul {
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content; /* Chrome */
}
</style>
